import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { errorText } from '../../lib/offsite'
import { useSession } from '../../lib/SessionContext'
import type { Session } from '../../lib/session'

/**
 * แถบเตือนตอนกำลังเข้าแทนพนักงาน (delegate)
 *
 * ⚠️ ต้องเห็นตลอดเวลาและเห็นชัด — ทุกหน้าที่เปิดระหว่างนี้แสดงข้อมูลของคนอื่น
 *    ถ้าแถบนี้หายไปหน้าไหน คนจะอ่านตัวเลขของพนักงานคนอื่นแล้วนึกว่าเป็นของตัวเอง
 */
export function DelegateBanner({ session }: { session: Session }) {
  const { call, refresh } = useSession()
  const navigate = useNavigate()
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const actingAs = session.kind === 'admin' ? session.actingAs : null

  async function stop() {
    setBusy(true)
    setError(null)
    try {
      await call('/api/admin/delegate/stop', { method: 'POST' })
      await refresh()
      navigate('/admin/delegate')
    } catch (err) {
      setError(errorText(err))
      setBusy(false)
    }
  }

  return (
    <div className="delegate-bar">
      <span>
        กำลังดูข้อมูลแทนพนักงาน <strong>{actingAs}</strong> — การเข้าครั้งนี้ถูกบันทึกไว้แล้ว
      </span>
      {error && <span className="error">{error}</span>}
      <button type="button" className="ghost" onClick={stop} disabled={busy}>
        {busy ? 'กำลังออก…' : 'ออกจากโหมดแทน'}
      </button>
    </div>
  )
}
